import { HERO } from "@/content";

export const Hero = () => (
  <section className="hero" id="inicio" data-testid="hero-section">
    <div className="wrap hero-grid">
      <div className="hero-copy">
        <p className="eyebrow">{HERO.eyebrow}</p>
        <h1>
          {HERO.titleLines[0]}
          <br />
          {HERO.titleLines[1]}
          <br />
          <em>{HERO.titleEmphasis}</em>
        </h1>
        <p>{HERO.text}</p>
        <div className="actions">
          <a
            className="btn gold"
            href={HERO.primaryCta.href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="hero-cta-whatsapp"
          >
            {HERO.primaryCta.label}
          </a>
          <a
            className="btn"
            href={HERO.secondaryCta.href}
            data-testid="hero-cta-atendimentos"
          >
            {HERO.secondaryCta.label}
          </a>
        </div>
      </div>
      <div className="hero-picture">
        <img src={HERO.image.src} alt={HERO.image.alt} fetchPriority="high" />
        <div className="hero-label">
          {HERO.label}
          <small>{HERO.labelSmall}</small>
        </div>
      </div>
    </div>
  </section>
);
